import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.css'
import VuePdfNoSss from 'vue-pdf/src/vuePdfNoSss.vue';
import '@/styles/index.scss' // global css

Vue.component('vue-pdf-no-sss', VuePdfNoSss);

// import qs from 'qs'
// import axios from 'axios'

// import SocketService from './utils/socket_service'  // echart
// 对服务端进行websocket的连接  
// SocketService.Instance.connect()

import filters from '@/filters/index'
for (let key in filters) {
    Vue.filter(key, filters[key])
}


//全局共用字典接口
import {
    getAllDict,
    getQueryAllTeacher,
    getQueryAllSales,
    getDimTableCharAndChildrenByType,
    getAllMyProject,
    getDimTableDeptByIds
} from "@/api/dict";

const dictApi = {
    getAllDict, // 字典类型
    getQueryAllTeacher, // 所有技术人员
    getQueryAllSales, // 所有销售人员
    getAllMyProject, // 下拉框内容,自己的项目ID
    getDimTableCharAndChildrenByType, // 字典类型
    getDimTableDeptByIds // 字典类型
};

// 使用 Vue 插件机制
Vue.use({
    install(Vue) {
        Object.assign(Vue.prototype, dictApi);
    }
});

// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar"
Vue.component('RightToolbar', RightToolbar)


import { postRequest2 } from './utils/api'
import { postRequest } from './utils/api'
import { postRequests } from './utils/api'
import { getRequest } from './utils/api'
import { getRequests } from './utils/api'
import { needPost } from './utils/api'
import { initMenu } from './utils/menus'
import { downloadRequest } from './utils/download'
//富文本注册
import '@/components/quillEditor/maxWindow.js'

// 引入字体文件
import './assets/font/iconfont.css'
// 引入全局的样式文件
import './assets/css/global.css'

Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'small' });
// // 分页组件
import Pagination from "@/components/Pagination";
Vue.component('Pagination', Pagination)
// Vue.prototype.$axios = axios
// Vue.prototype.$qs = qs
// 插件形式使用请求   好多地方都要用所有放在main.js中
import { resetForm, doesItContain, timestampToYYYYMMDD, dateTimeTwoLine, } from "@/utils/validate";
//全局共用字典接口

Vue.prototype.postRequest2 = postRequest2
Vue.prototype.postRequest = postRequest
Vue.prototype.needPost = needPost
Vue.prototype.postRequests = postRequests
Vue.prototype.getRequest = getRequest
Vue.prototype.getRequests = getRequests
Vue.prototype.downloadRequest = downloadRequest

Vue.prototype.resetForm = resetForm
Vue.prototype.doesItContain = doesItContain
Vue.prototype.timestampToYYYYMMDD = timestampToYYYYMMDD
// 日期时间列两行显示（el-table-column 的 :formatter，需配合 class-name="cell-two-line"）
Vue.prototype.dateTimeTwoLine = dateTimeTwoLine

/* ---------------------------------------------------------------------------
 * 字典缓存的安全读写（各页面把下拉选项缓存到 sessionStorage）
 * ---------------------------------------------------------------------------
 * 页面里的原始写法是：
 *     if (!sessionStorage.getItem(key)) { 请求.then(resp => { this.x = resp.result;
 *         sessionStorage.setItem(key, JSON.stringify(resp.result)) }) }
 *     else { this.x = JSON.parse(sessionStorage.getItem(key)) }
 * 有两个坑：
 *   1) 请求失败时 `if (resp)` 不成立 → 既不赋值也不写缓存（下拉空着，只能切页面重进）
 *      —— 这条由 utils/api.js 的"只读请求自动重试"兜住；
 *   2) 若某次"成功但 result 为空"被写进缓存，会存成字符串 "undefined"，
 *      之后每次 JSON.parse("undefined") 直接抛错，下拉**永远**空、切页面也不好
 *      —— 这条由下面两个方法兜住：坏值自动清除、空值不写缓存。
 * ------------------------------------------------------------------------- */
Vue.prototype.dictCache = function (key, fallback) {
  const empty = fallback === undefined ? [] : fallback
  let raw = null
  try {
    raw = window.sessionStorage.getItem(key)
  } catch (e) {
    return empty
  }
  if (!raw) return empty
  try {
    const val = JSON.parse(raw)
    if (val === undefined || val === null) {
      console.warn('[dictCache] 缓存 ' + key + ' 是空值，已清除，稍后会重新请求')
      window.sessionStorage.removeItem(key)
      return empty
    }
    return val
  } catch (e) {
    console.warn('[dictCache] 缓存 ' + key + ' 解析失败（值=' + String(raw).slice(0, 20) + '），已清除，稍后会重新请求')
    try { window.sessionStorage.removeItem(key) } catch (e2) {}
    return empty
  }
}

Vue.prototype.saveDictCache = function (key, val) {
  const isNonEmptyArray = Array.isArray(val) && val.length > 0
  const isNonEmptyObject = val && typeof val === 'object' && !Array.isArray(val) && Object.keys(val).length > 0
  if (!isNonEmptyArray && !isNonEmptyObject) {
    // 空数据不写缓存：下次进入页面会重新请求（配合只读重试，抖动可自愈）
    console.warn('[saveDictCache] ' + key + ' 取到空数据，跳过写缓存')
    return val
  }
  try {
    window.sessionStorage.setItem(key, JSON.stringify(val))
  } catch (e) {
    console.warn('[saveDictCache] ' + key + ' 写入缓存失败：' + (e && e.message))
  }
  return val
}

// 将全局的echarts对象挂载到Vue的原型对象上； 别的组件中 通过 this.echarts 就可以使用
Vue.prototype.echarts = window.echarts

// 将axios挂载到Vue的原型对象上
// 在别的组件中 通过 this.$http 就可以使用   $http 是自己随便起的名字
// Vue.prototype.$http = axios     

// 定义白名单
const whiteList = ['/', '/forgetPwd']; 

router.beforeEach((to, from, next) => {
    // 检查当前路径是否在白名单中
    if (whiteList.includes(to.path)) { 
        if (to.path === '/') {
            sessionStorage.clear();
            // localStorage.clear();
        }
        next();
        return;
    }

    if (window.sessionStorage.getItem('userIdStr')) {
        if (!window.sessionStorage.getItem('user')) {
            // 判断用户信息是否存在
            return getRequest('/user/info').then(resp => {
                if (resp) {
                    // 存入用户信息
                    window.sessionStorage.setItem('user', JSON.stringify(resp.result));
                    store.commit('INIT_USER', resp.result);
                    initMenu(router, store);   // 已登录
                    // 写入 user信息到 全局的 vuex中, 其中 INIT_USER 是 store/index.js 提供的方法
                    next();
                }
            });
        } else { // 用户信息存在
            initMenu(router, store);   // 已登录
            next();
        }
    } else {
        next('/?redirect=' + to.path);
    }
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
